import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";

const statisticsTotalsUrlApi = environment.statisticsTotalsUrlApi;
const statisticsIncidentsTodayUrlApi =
  environment.statisticsIncidentsTodayUrlApi;
const statisticsIncidentsLastMonthUrlApi =
  environment.statisticsIncidentsLastMonthUrlApi;
const gpsAllIncidentsUrlApi = environment.gpsAllIncidentsUrlApi;

@Injectable()
export class DashboardService {
  constructor(private http: HttpClient) {}

  getStatisticsTotals() {
    return this.http
      .request("GET", `${statisticsTotalsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }

  getStatisticsIncidentsToday() {
    return this.http
      .request("GET", `${statisticsIncidentsTodayUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getStatisticsIncidentsLastMonth() {
    return this.http
      .request("GET", `${statisticsIncidentsLastMonthUrlApi}`, {
        responseType: "json",
      })
      .pipe(map((resp: any) => resp));
  }

  getGpsAllIncidents() {
    return this.http
      .request("GET", `${gpsAllIncidentsUrlApi}`, { responseType: "json" })
      .pipe(map((resp: any) => resp));
  }
}
